import { Paper } from "@mui/material";
import { useRecommendedContext } from "../../../context/recommended/RecommendedContext";
import { Box } from "@mui/system";
import RecommendedSettingAddSettingModal from "./RecommendedSettingAddSettingModal";
import React, { useEffect, useState } from "react";
import RecommendedSettingFormButton from "./RecommendedSettingFormButton";
import RecommendedSettingConfig from "./RecommendedSettingConfig";
import useResponsive from "../../../components/hooks/useResponsive";
import ThreeDotsLoading from "../../../components/loader/ThreeDotsLoading";
import RecommendedAddSetting from "../RecommendedAddSetting";
import { ListDivider } from "../../../ui/ListStyles";
import RecommendedSettingForm from "./RecommendedSettingForm";
import RecommendedSettingFormMobile from "./RecommendedSettingFormMobile";

const RecommendedSetting = () => {
  const { config, currentConfig, setEditedName } = useRecommendedContext();

  const { isMd } = useResponsive();

  const [openAddModal, setOpenAddModal] = useState(false);
  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  //SETTING NAME SET INTO EDITEDNAME STATE FOR SHOWING IN TEXTFIELD
  useEffect(() => {
    if (currentConfig?.name) {
      setEditedName(currentConfig.name);
    }
  }, [currentConfig]);

  const hasData = config?.data?.config_list?.length;

  if (hasData === undefined)
    return <ThreeDotsLoading bgWidth="100%" bgHeight="90vh" size={10} />;

  return (
    <>
      {hasData ? (
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {isMd ? (
            <RecommendedSettingForm handleOpenAddModal={handleOpenAddModal} />
          ) : (
            <RecommendedSettingFormMobile
              handleOpenAddModal={handleOpenAddModal}
            />
          )}

          {/*MODAL FOR ADD NEW NAME*/}
          <RecommendedSettingAddSettingModal
            openAddModal={openAddModal}
            handleCloseAddModal={handleCloseAddModal}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <RecommendedSettingConfig
              title="تابلو خوانی"
              keyName="marketwatch"
            />
            <RecommendedSettingConfig title="بنیادی" keyName="foundamental" />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: isMd ? "row" : "column",
                gap: isMd ? "20px" : "10px",
              }}
            >
              <RecommendedSettingFormButton />
            </Box>
          </Box>
        </Paper>
      ) : (
        <RecommendedAddSetting />
      )}
    </>
  );
};

export default RecommendedSetting;
